module.exports = __webpack_public_path__ + "media/application/images/2018/my-consumer-accordian-94b006131a3974f9a9a1b556045df7c4.png";